// lib
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Calendar as LibCalendar } from "react-big-calendar";
import moment from "moment";
// src
import { getVisibleRange } from "utils/ranges";
import { currentLocalizer } from "i18n/localizer";
import DateHeader from "./partials/DateHeader";
import Toolbar from "./partials/Toolbar";

const classInRange = (current, focus, view, timelineStart, timelineEnd) => {
  let start;
  let end;
  if (view === "timeline") {
    if (timelineStart) {
      [start, end] = [timelineStart, timelineEnd];
    } else {
      // initial timeline setting
      [start, end] = [moment(focus).startOf("day").valueOf(), moment(focus).endOf("day").valueOf()];
    }
  } else {
    [start, end] = getVisibleRange(focus, view);
  }
  if (current < start || current > end) return null;
  const isStart = moment(start).diff(current, "days") === 0;
  const isEnd = moment(end).diff(current, "days") === 0;
  if (isStart) return isEnd ? "in-range start end" : "in-range start";
  return isEnd ? "in-range end" : "in-range";
};

const DatePicker = ({ focus, language, timelineEnd, timelineStart, view }) => {
  const start = view === "timeline" && timelineStart ? new Date(timelineStart) : focus;
  const [date, setDate] = useState(start);

  // Coming from calendar and timeline
  useEffect(() => {
    if (view !== "timeline") setDate(focus);
  }, [focus, view]);
  useEffect(() => {
    if (timelineStart) setDate(new Date(timelineStart));
  }, [timelineStart]);

  const styleDay = (day) => {
    if (view === "month") return null;
    return { className: classInRange(day, focus, view, timelineStart, timelineEnd) };
  };

  const localizer = currentLocalizer(language);
  const formats = {
    weekdayFormat: (d) => localizer.format(d, "dd"),
  };
  return (
    <LibCalendar
      date={date}
      dayPropGetter={styleDay}
      onNavigate={setDate}
      components={{ toolbar: Toolbar, dateHeader: DateHeader }}
      events={[]}
      formats={formats}
      localizer={localizer}
      selectable
      style={{ height: "225px" }}
      views={["month"]}
    />
  );
};

DatePicker.propTypes = {
  // data props
  focus: PropTypes.object.isRequired,
  language: PropTypes.string.isRequired,
  timelineEnd: PropTypes.number,
  timelineStart: PropTypes.number,
  view: PropTypes.string.isRequired,
};

DatePicker.defaultProps = {
  timelineEnd: null,
  timelineStart: null,
};

export default DatePicker;
